export function usesProtectedPlayback({
  firebaseConfigured,
  demoMode
}: {
  firebaseConfigured: boolean;
  demoMode: boolean;
}): boolean {
  // Access mode is an authentication/session property. Catalog contents must
  // never turn a signed-in family into an unmetered public playback client.
  return firebaseConfigured && !demoMode;
}
